// 条数localStorage存储key
export const localPageKey = '_localKey_page'

// 默认条数localStorage存储key
export const localPageSizeKey = '_localKey_pageSize'

// 页码默认值
const defaultPageSizes = [10, 20, 50, 100, 200, 300]

// 页码组件可选条数设置
export const pageSizes = localStorage.getItem(localPageKey) ? JSON.parse(localStorage.getItem(localPageKey)) : defaultPageSizes

// 页码默认条数
export const pageSize = localStorage.getItem(localPageSizeKey) ? Number(localStorage.getItem(localPageSizeKey)) : pageSizes[0] || 10

// 用户token存储key名
export const userTokenKey = "_ays_tk"

// 浏览器版本要求
export const browserVersion = 90

// 视频格式
export const videoTypes = ['mp4', 'wmv', 'avi']

// 标签localStorage存储key
export const localLabelKey = '_localKey_label'

// pda扫码message持续时间
export const pdaMessageScanDuration = 2000

// 默认扫码持续时间
export const scanMessageDefaultDuration = 3000

// pda宽度
export const pdaScreenWidth = 768

// 回收申请手术间存储key
export const recycleApplySurgeryDepKey = '_localKey_recycleApply_surgeryDep'

// 系统内部条形码
export const sysCodeRules = [
  {
    content: 'honjo001', // 用于确认操作
    id: 'hj001'
  },
  {
    content: 'honjo002', // 用于取消操作
    id: 'hj002'
  }
]
// 外部码规则
export const thirdCodeRules = [
  { // rfid
    rule: new RegExp(/^\$.+?\$$/),
    length: 0,
    id: 'td001'
  }
]

// 回收清点回收人存储key
export const recycleUserKey = '_recycle_receiver'

// 回收清点下收人存储key
export const recycleHandlerKey = '_recycle_handler'

// 科室无菌库过期物品数量
export const departmentSterilityLibraryExpire = '_expire_number'

// 语言设置key
export const langKey = '_ays_lang'

// 后端设置语言key
export const apiLangKey = '_ays_lang_api'

// 可选语言包（需要对应语言包文件： src/lang/xx.js）
export const langs = [
  {
    langKey: 'local.object.chinese',
    name: '简体中文', // 中文名称
    localKey: 'zh-s', // 本地语言包的名称和文件名
    momentKey: 'zh-cn', // moment插件对应语言标识
    voiceKey: 'zh-CN', // 语音播报对应语言标识
    apiKey: 'zh_CN' // 后端接口对应标识
  },
  {
    langKey: 'local.object.triditionalCN',
    name: '繁體中文',
    localKey: 'zh-t',
    momentKey: 'zh-hk',
    voiceKey: 'zh-HK',
    apiKey: 'zh_HK'
  },
  {
    name: 'English',
    langKey: 'local.object.english',
    localKey: 'en',
    momentKey: 'en-gb',
    voiceKey: 'en-GB',
    apiKey: 'en'
  },
  {
    name: 'แบบไทย',
    langKey: 'local.object.thai',
    localKey: 'th',
    momentKey: 'th',
    voiceKey: 'th-TH',
    apiKey: 'th'
  },
]

// 默认语言包
export const defaultLang = 'zh-s' //'zh-s'(简中), 'zh-t'(繁中), 'en'(英文), 'th'(泰语)

// 使用语言包配置
export const lang = localStorage.getItem(langKey) || defaultLang

// 打印扣除次数提醒localStorage记忆key
export const printWarningKey = '_printWarning'

// 免登录访问页面
export const tokenFreePages = [
  '/login',
  '/portal'
]

// 免权限访问页面
export const permissionFreePages = [
  '/sys-config',
  '/404',
  '/index',
  '/portal',
  '/'
]

// app下载页面地址
export const appDownloadPageUrl = 'https://hlms.honjoinfo.com:8096/download'

// 国家与地图对应关系
export const countryMap = {
  'CN': {
    'name': 'china',
    'center': [105.283042, 35.86119]
  },
  'MY': {
    'name': 'mas',
    'center': [109.6163, 4.2105]
  }
}

// 地图绘制symbol
export const symbolPath = 'M513.044898 909.061224c-6.791837 0-13.061224-3.134694-17.763265-7.836734-2.612245-3.134694-63.738776-72.620408-125.387755-170.840817-36.571429-57.991837-65.828571-113.371429-86.726531-165.616326-26.644898-66.35102-40.228571-126.955102-40.228571-180.244898 0-72.097959 28.212245-139.493878 78.889795-190.171429S440.42449 114.938776 512 114.938776s139.493878 28.212245 190.171429 78.889795 78.889796 118.595918 78.889795 190.171429c0 53.289796-13.583673 114.416327-39.706122 180.244898-20.897959 52.244898-49.632653 107.62449-86.204082 165.616326-61.64898 98.220408-122.253061 167.706122-124.865306 170.318368-4.179592 5.746939-10.44898 8.881633-17.240816 8.881632zM512 510.955102c-67.395918 0-121.730612-54.857143-121.730612-121.730612S444.604082 267.493878 512 267.493878s121.730612 54.857143 121.730612 121.730612S579.395918 510.955102 512 510.955102z'